import React from "react";
import { Button } from "primereact/button";

export default function ButtonComponent({ type, onClick, label, loading, className, disable = false, ...props }) {
    return <Button type={type} label={label} onClick={onClick} loading={loading} disabled={disable} className={className} {...props} />;
}
